module.exports = __webpack_public_path__ + "static/media/language_course_bottom.357ef76d.png";